import React from 'react';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS, FUNNELS, ARHI_RESIDENTIAL_FUNNELS } from '../../util/constants';
import BaseAgreement from '../base-agreement';
import DIRECT_DEBIT_RULES_LINKS from './links';
const TITLES = {
  ARHI: LABELS.DIRECT_DEBIT_TITLE
};
const DESCRIPTIONS = {
  ARHI: LABELS.FUND_RULES_DESCRIPTION
};
const DIRECT_DEBIT_LABEL_DIRECT_DEBIT = {
  ARHI: LABELS.DIRECT_DEBIT_LABEL_DIRECT_DEBIT_ARHI,
  IWHI: LABELS.DIRECT_DEBIT_LABEL_DIRECT_DEBIT,
  IMAN: LABELS.DIRECT_DEBIT_LABEL_DIRECT_DEBIT,
  ISHI: LABELS.DIRECT_DEBIT_LABEL_DIRECT_DEBIT
};
const DIRECT_DEBIT_LABEL_CREDIT_CARD = {
  ARHI: LABELS.DIRECT_DEBIT_LABEL_DIRECT_DEBIT_ARHI,
  IWHI: LABELS.DIRECT_DEBIT_LABEL_CREDIT_CARD,
  IMAN: LABELS.DIRECT_DEBIT_LABEL_CREDIT_CARD,
  ISHI: LABELS.DIRECT_DEBIT_LABEL_CREDIT_CARD
};
const DirectDebitServiceAgreement = props => {
  const {
    funnel = FUNNELS.ARHI,
    values,
    paymentMethod,
    label,
    links,
    creditCardLabel,
    directDebitLabel,
    id = 'directDebitServiceAgreement',
    name = 'directDebitServiceAgreement'
  } = props;
  const listOfLinks = links || DIRECT_DEBIT_RULES_LINKS[funnel] || DIRECT_DEBIT_RULES_LINKS.ARHI;
  const isCreditCard = paymentMethod === 'CreditCard';
  let labelText = label;
  if (!labelText) {
    if (ARHI_RESIDENTIAL_FUNNELS[funnel || '']) {
      labelText = LABELS.DIRECT_DEBIT_CREDIT_CARD_LABEL_ARHI;
      const ccLabel = creditCardLabel;
      const ddLabel = directDebitLabel;
      // apply custom labels if provided
      if (isCreditCard && ccLabel) labelText = ccLabel;
      if (!isCreditCard && ddLabel) labelText = ddLabel;
    } else {
      const ccLabel = creditCardLabel || DIRECT_DEBIT_LABEL_CREDIT_CARD[funnel] || DIRECT_DEBIT_LABEL_CREDIT_CARD.ARHI;
      const ddLabel = directDebitLabel || DIRECT_DEBIT_LABEL_DIRECT_DEBIT[funnel] || DIRECT_DEBIT_LABEL_DIRECT_DEBIT.ARHI;
      labelText = isCreditCard ? ccLabel : ddLabel;
    }
  }
  const title = props.title || TITLES[funnel] || TITLES.ARHI;
  const description = props.description || DESCRIPTIONS[funnel] || DESCRIPTIONS.ARHI;
  return React.createElement(BaseAgreement, {
    ...props,
    id: id,
    name: name,
    funnel: funnel,
    values: values,
    title: title,
    description: description,
    links: listOfLinks,
    fieldLabel: LABELS.FUND_RULES_FIELD_LABEL,
    label: labelText
  });
};
const DirectDebitServiceAgreementWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(DirectDebitServiceAgreement, {
  ...props
}));
DirectDebitServiceAgreement.defaultProps = {
  id: 'directDebitServiceAgreement',
  name: 'directDebitServiceAgreement'
};
export default DirectDebitServiceAgreementWithFunnel;